module.exports = __webpack_public_path__ + "static/media/teespring.96620e0f.svg";